var $35175b1ad320fcc1$exports = {};
$35175b1ad320fcc1$exports = {
    "alert": `\u{12E}sp\u{117}jimas`,
    "dismiss": `Atmesti`
};


export {$35175b1ad320fcc1$exports as default};
//# sourceMappingURL=lt-LT.module.js.map
